"use strict";

exports.__esModule = true;
exports.PLUGIN_PRIORITY = exports.PLUGIN_KEY = exports.Comments = void 0;
var _comments = require("./comments");
exports.PLUGIN_KEY = _comments.PLUGIN_KEY;
exports.PLUGIN_PRIORITY = _comments.PLUGIN_PRIORITY;
exports.Comments = _comments.Comments;


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/plugins/comments/index.js
// module id = 1285
// module chunks = 0